module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0054.26f037c9.jpg";